export default {
  authRefreshTime: 50 * 60 * 1000,
  recaptchaApiKey: "6Lc2DBMUAAAAAGHPHclUIJgeVQWZPsyzByCX13Rr", //50 minutes
};



// WEBPACK FOOTER //
// ./config/production.js